import React, { Fragment, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import store from 'store';
import { connect } from 'react-redux';
import { useAuth } from '../../context/authProvider';
// import { usePermissionsOnly } from '../../helpers/license';
/*
|UI
*/
import { Button, Typography, Divider, Drawer, Tag, Card, Space, Badge, Progress, Switch} from 'antd'
import {   Media } from 'reactstrap';
import {  Row, Col } from 'react-bootstrap';
import Flex from '../common/Flex';
import AvatarUser from '../common/AvatarUser';
import ButtonIcon     from '../common/ButtonIcon';
/*
|ICONS
*/
import { PiArrowRightBold, PiCrownSimpleDuotone, PiGearSixDuotone, PiListChecksDuotone } from 'react-icons/pi';

import { CrownOutlined, SettingOutlined, TeamOutlined } from '@ant-design/icons';
import AppContext from '../../context/Context';

const ProfileDropdown = ({dispatch}) => {

  const { auth, logout } = useAuth();
  // const { permissions } = usePermissionsOnly();

  const {
    config: { developerMode, isDark },
    setConfig
  } = useContext(AppContext);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const {Text} = Typography;

  // Handle test mode toggle
  const handleTestModeChange = (checked) => {
    setConfig('developerMode', checked);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  // Handle dark/light mode toggle
  const handleThemeChange = (checked) => {
    setConfig('isDark', checked);
  };

  // Get license plan info
  const licensePlan = auth?.user?.extra?.privileges?.license_plan;
  const planDisplayName = licensePlan ? licensePlan.charAt(0).toUpperCase() + licensePlan.slice(1) : 'Free';
  
  const getPlanColor = (plan) => {
    switch(plan) {
      case 'enterprise': return 'gold';
      case 'standard': return 'blue';
      case 'starter': return 'green';
      default: return 'default';
    }
  };

  const getPlanIcon = (plan) => {
    switch(plan) {
      case 'enterprise': return <CrownOutlined />;
      case 'standard': return <TeamOutlined />;
      case 'starter': return <SettingOutlined />;
      default: return <SettingOutlined />;
    }
  };

  return (
    <Fragment>
      {/* <Space orientation="horizontal"  size="small"> */}
        <Button
          color="default" variant="filled"
          className='m-0 p-0'
          icon={<AvatarUser size='small' extra={auth?.user?.extra} className='m-0 p-0' />}
          onClick={() => setDrawerOpen(true)}
        >
        </Button>
      {/* </Space> */}

    {auth?.user?.extra && (
    <Drawer title="Account" placement="right" onClose={()=> setDrawerOpen(false)} open={drawerOpen} size={400}>

        <Divider titlePlacement="start"  plain>Your Profile</Divider>
        <Row>
          <Col>
            <Card 
                size="small" 
                title={
                    <Space>
                        <PiArrowRightBold />
                        <Link to={`/profile`} onClick={() => setDrawerOpen(false)}>
                            Go to my profile
                        </Link>
                    </Space>
                }
                extra={[
                  <Button
                  color="default" variant="filled"
                  size='small'
                  style={{lineHeight:'normal'}}
                  onClick={logout}
                  >
                    Sign Out
                </Button> 
                ]}
            >
                <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <AvatarUser extra={auth.user.extra} size={48} />
                        <div>
                            <Text strong style={{ fontSize: '16px' }}>
                                {auth.user.extra.full_name}
                            </Text>
                            <br />
                            <Text type="secondary">
                                {auth.user.email}
                            </Text>
                        </div>
                    </div>
                </Space>
            </Card>          
          </Col>
        </Row>

        <Divider titlePlacement="start"  plain>Subscription Plan</Divider>
        <Row>
          <Col>
            <Card size="small">
              <Space orientation="vertical" style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Space>
                    {getPlanIcon(licensePlan)}
                    <Text strong>{planDisplayName} Plan</Text>
                  </Space>
                  <Tag color={getPlanColor(licensePlan)} icon={getPlanIcon(licensePlan)}>
                    {planDisplayName}
                  </Tag>
                </div>
                
                {licensePlan && (
                  <div>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      Active features: {auth.user?.extra?.privileges?.permissions?.length || 0} permissions
                    </Text>
                  </div>
                )}
                
                <Link 
                  to="/licenses" 
                  onClick={() => setDrawerOpen(false)}
                  style={{ fontSize: '12px' }}
                >
                  <PiGearSixDuotone className="me-1" />
                  Manage Subscription
                </Link>
              </Space>
            </Card>
          </Col>
        </Row>

        {/* <Divider titlePlacement="start"  plain>Preferences</Divider>
        <Row>
          <Col>
            <Card size="small">
              <Space orientation="vertical" style={{ width: '100%' }} size="middle">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text strong>Dark Mode</Text>
                  <Switch 
                    size="large" 
                    checkedChildren="Dark" 
                    unCheckedChildren="Light" 
                    onChange={handleThemeChange} 
                    checked={isDark}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text strong>Test Mode</Text>
                  <Switch 
                    size="large" 
                    checkedChildren="Test mode on" 
                    unCheckedChildren="Test mode off" 
                    onChange={handleTestModeChange} 
                    checked={developerMode}
                    className="ant-switch-warning"
                    style={{
                      backgroundColor: developerMode ? '#CC4B00' : undefined
                    }}
                  />
                </div>
              </Space>
            </Card>
          </Col>
        </Row> */}

        <Divider titlePlacement="start"  plain>Quick Actions</Divider>
        <Row>
          <Col>
            <Space orientation="vertical" style={{ width: '100%' }} size="small">
              <Link to="/settings" onClick={() => setDrawerOpen(false)} style={{ display: 'block', textAlign: 'left' }}>
                  Admin Settings

              </Link>
              <Link to="/users/list" onClick={() => setDrawerOpen(false)} style={{ display: 'block', textAlign: 'left' }}>
                  Manage Users
              </Link>
              <Link to="/licenses" onClick={() => setDrawerOpen(false)} style={{ display: 'block', textAlign: 'left' }}>
                  License Management
              </Link>
            </Space>
          </Col>
        </Row>
      </Drawer>
    )}
    </Fragment>
  );
};

export default ProfileDropdown
